import {useState} from "react";

import md5 from "md5";

import {useServerClient} from "../useServerClient";
import {useServerParams} from "../useServerParams";

export const targetTypes = {
    apiKey: "api_key"
};

export const generateHashKey = ({
    apiKey = "",
    secretKey = ""
}) => {

    // console.log('input', apiKey, secretKey)

    let hash1Payload = `${apiKey}${secretKey}`;

    let hash1 = md5 (hash1Payload);

    // console.log('hash1', hash1, hash1Payload)

    let hash2Payload = `${apiKey}${hash1}`;

    let finalHash = md5 (hash2Payload);

    // console.log('finalHash', finalHash, hash2Payload)

    return finalHash;
};

export function useUserApiKeys ({
    targetType: _targetType = targetTypes.apiKey
})
{

    const [targetType, setTargetType] = useState (_targetType);

    const {makeCall, getError} = useServerClient ();
    const {
        getListsUrl,
        getUrlWithDataTypes,
        _operatorDef: filterOperatorTypes
    } = useServerParams ();

    const [isLoading, setIsLoading] = useState (false);

    const endpoint1 = "user";
    const endpoint2 = "users";

    const list = async (props) => {

        setIsLoading (true);

        try
        {

            let url = getListsUrl (`${endpoint2}/${targetType}`, props);

            const response = await makeCall ({
                url,
                method: "GET",
                payload: {}
            });

            setIsLoading (false);

            return response;

        } catch (error)
        {

            setIsLoading (false);
            throw error;

        }
    };

    const get = async ({id, dataTypesArray = []}) => {

        setIsLoading (true);

        try
        {

            let url = getUrlWithDataTypes (`${endpoint1}/${targetType}/${id}`,
                  dataTypesArray
            );

            const response = await makeCall ({
                url,
                method: "GET",
                payload: {}
            });

            setIsLoading (false);

            return response;

        } catch (error)
        {

            setIsLoading (false);
            throw error;

        }

    };

    const create = async ({data}) => {

        setIsLoading (true);

        try
        {

            let url = `${endpoint1}`;

            let postData = {
                scope: {
                    target: targetType,
                    action: ""
                },
                payload: data
            };

            const response = await makeCall ({
                url,
                method: "POST",
                payload: postData
            });

            setIsLoading (false);

            return response;

        } catch (error)
        {

            setIsLoading (false);
            throw error;

        }

    };

    const update = async ({id, data}) => {

        setIsLoading (true);

        try
        {

            let url = `${endpoint1}/${id}`;

            const postData = {
                scope: {
                    target: targetType,
                    action: ""
                },
                payload: data
            };

            const response = await makeCall ({
                url,
                method: "PUT",
                payload: postData
            });

            setIsLoading (false);

            return response;

        } catch (error)
        {

            setIsLoading (false);
            throw error;

        }

    };

    const remove = async ({ids}) => {

        setIsLoading (true);

        if (ids.length <= 0)
        {
            throw getError (false, `Please select at least (1) items`);
        }

        try
        {

            let url = `${endpoint2}/delete`;

            const postData = {
                scope: {
                    target: targetType
                },
                payload: {
                    ids
                }
            };

            const response = await makeCall ({
                url,
                method: "POST",
                payload: postData
            });

            setIsLoading (false);

            return response;

        } catch (error)
        {

            setIsLoading (false);
            throw error;

        }

    };

    return {
        isLoading,
        filterOperatorTypes,
        targetTypes,
        list,
        get,
        create,
        update,
        remove
    };
}